import { render, staticRenderFns } from "./TenancyDepositReleaseManual.vue?vue&type=template&id=9a22714a&"
import script from "./TenancyDepositReleaseManual.vue?vue&type=script&lang=js&"
export * from "./TenancyDepositReleaseManual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports